import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface User {
	token: string;
	username: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
	private readonly userTokenKey = 'wo-user-token';
	private readonly userTokenSubject = new BehaviorSubject<string | null>(null);
	userToken$ = this.userTokenSubject.asObservable();

	constructor() {
		const token = this.getToken();
		if (token) {
			this.userTokenSubject.next(token);
		}
	}

	setUser(user: User): void {
		localStorage.setItem(this.userTokenKey, user.token);
		this.userTokenSubject.next(user?.token);
	}

	removeUser(): void {
		localStorage.removeItem(this.userTokenKey);
		this.userTokenSubject.next(null);
	}

	private getToken(): string | null {
		return localStorage.getItem(this.userTokenKey);
	}
}
